import { Card } from "react-bootstrap";
import styles from "../../../assets/styles/Project.module.css";
import styleUtils from "../../../assets/styles/utils.module.css";
import { District } from "../../../services/models/district";
import { MdDelete, MdEdit } from "react-icons/md";

interface DistrictCardProps {
    district: District,
    onDistrictClicked: (district: District) => void,
    onUpdateDistrictClicked: (district: District) => void,
    onDeleteDistrictClicked: (district: District) => void,
    className?: string,
}

const DistrictCard = ({district, onDistrictClicked, onUpdateDistrictClicked, onDeleteDistrictClicked, className}: DistrictCardProps) => {
    const { name } = district;
    return(
        <Card
        className={`${styles.projectCard} ${className}`}
        onClick={(e) => {
            onDistrictClicked(district);
            e.stopPropagation();
        }}
        >
        <Card.Body className={styles.cardBody}>
            <Card.Title className={styleUtils.flexCenterSpaceBetween}>
                {name}
                <div>
                    <MdEdit
                        className="ms-2 text-muted ms-rights"
                        onClick={(e) => {
                            onUpdateDistrictClicked(district);
                            e.stopPropagation();
                        }}
                    />
                    <MdDelete
                        className="ms-2 text-muted ms-right"
                        onClick={(e) => {
                            onDeleteDistrictClicked(district);
                            e.stopPropagation();
                        }}
                    />
                </div>
            </Card.Title>
        </Card.Body>
    </Card>
    );
}

export default DistrictCard